import { createContext, useContext } from "react";

export type ThreadHydrationStatus = "pending" | "success" | "error";

export type ThreadHydrationContextValue = {
  status: ThreadHydrationStatus;
  error: Error | null;
  retry: () => Promise<void>;
};

const defaultValue: ThreadHydrationContextValue = {
  status: "pending",
  error: null,
  retry: async () => undefined,
};

export const ThreadHydrationContext = createContext(defaultValue);

export const useThreadHydration = () => useContext(ThreadHydrationContext);
